class WebStoriesList {

    static ytAPILoader = null;

    static loadYouTubeAPI() {
        if (WebStoriesList.ytAPILoader) return WebStoriesList.ytAPILoader;

        WebStoriesList.ytAPILoader = new Promise(resolve => {
            if (window.YT && window.YT.Player) {
                resolve(window.YT);
                return;
            }
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(tag);
            window.onYouTubeIframeAPIReady = () => resolve(window.YT);
        });

        return WebStoriesList.ytAPILoader;
    }

    constructor() {
        this.sections = document.querySelectorAll('.block-webstories-list');
        this.filterSelect = document.getElementById('filter-topic');
        this.contentContainer = document.getElementById('webstories-content');
        this.loadingIndicator = document.getElementById('loading-indicator');
        this.prevBtn = document.getElementById('prev-btn');
        this.nextBtn = document.getElementById('next-btn');
        this.currentPageSpan = document.getElementById('current-page');
        this.lastPageSpan = document.getElementById('last-page');

        this.initializeFromURL();
        this.initializeFromDOM();
        this.initEvents();
        this.startHoverVideo();
    }

    initializeFromURL() {
        const urlPath = window.location.pathname;
        const urlParams = new URLSearchParams(window.location.search);

        const pathParts = urlPath.split('/');
        if (pathParts.length > 2 && pathParts[2]) {
            this.currentTag = pathParts[2];
            this.filterSelect.value = this.currentTag;
        } else {
            this.currentTag = '';
        }

        const pageParam = urlParams.get('page');
        this.currentPage = pageParam ? parseInt(pageParam) : 1;

        this.currentPageSpan.textContent = this.currentPage;
    }


    initializeFromDOM() {
        this.currentPage = parseInt(this.currentPageSpan.textContent) || 1;
        this.lastPage = parseInt(this.lastPageSpan.textContent) || 1;

        this.isPrevDisabled = this.prevBtn.hasAttribute('disabled');
        this.isNextDisabled = this.nextBtn.hasAttribute('disabled');

        this.updatePaginationState();
    }

    updatePaginationState() {
        this.prevBtn.disabled = this.currentPage <= 1 || this.isPrevDisabled;
        this.nextBtn.disabled = this.currentPage >= this.lastPage || this.isNextDisabled;

        if (this.prevBtn.disabled) {
            this.prevBtn.href = '#';
            this.prevBtn.style.pointerEvents = 'none';
            this.prevBtn.style.opacity = '0.5';
        } else {
            this.prevBtn.href = this.buildPageURL(this.currentTag, this.currentPage - 1);
            this.prevBtn.style.pointerEvents = 'auto';
            this.prevBtn.style.opacity = '1';
        }

        if (this.nextBtn.disabled) {
            this.nextBtn.href = '#';
            this.nextBtn.style.pointerEvents = 'none';
            this.nextBtn.style.opacity = '0.5';
        } else {
            this.nextBtn.href = this.buildPageURL(this.currentTag, this.currentPage + 1);
            this.nextBtn.style.pointerEvents = 'auto';
            this.nextBtn.style.opacity = '1';
        }
    }

    showLoading() {
        this.loadingIndicator.classList.remove('hidden');
        this.contentContainer.style.opacity = '0.5';
    }

    hideLoading() {
        this.loadingIndicator.classList.add('hidden');
        this.contentContainer.style.opacity = '1';
    }

    updateURL(tag = '', page = 1) {
        let url = '/webstories';

        if (tag) {
            url += '/' + tag;
        }

        if (page > 1) {
            const separator = url.includes('?') ? '&' : '?';
            url += separator + 'page=' + page;
        }

        window.history.pushState({
            tag: tag,
            page: page
        }, '', url);
    }

    createChunkedHTML(htmlString) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        const items = Array.from(tempDiv.children);

        // Se não há itens, retorna mensagem de "nenhum encontrado"
        if (items.length === 0) {
            return `
                <div class="container py-6">
                    <p class="text-center text-lg text-dark">Nenhum webstory encontrado.</p>
                </div>
            `;
        }

        let chunkedHTML = '';

        for (let i = 0; i < items.length; i += 4) {
            const chunk = items.slice(i, i + 4);
            const rowIndex = Math.floor(i / 4);
            const bgClass = rowIndex % 2 === 0 ? 'bg-white' : 'bg-light';

            chunkedHTML += `<div class="${bgClass}">`;
            chunkedHTML += '<div class="container grid grid-cols-1 gap-6 py-6 sm:grid-cols-2 md:grid-cols-4">';

            chunk.forEach(item => {
                chunkedHTML += item.outerHTML;
            });

            chunkedHTML += '</div>';
            chunkedHTML += '</div>';
        }

        return chunkedHTML;
    }

    updatePagination(pagination) {
        this.currentPageSpan.textContent = pagination.current_page;
        this.lastPageSpan.textContent = pagination.last_page;

        this.currentPage = pagination.current_page;
        this.lastPage = pagination.last_page;
        this.isPrevDisabled = pagination.on_first_page;
        this.isNextDisabled = !pagination.has_more_pages;

        // Atualiza estado dos botões
        this.updatePaginationState();
    }

    buildPageURL(tag = '', page = 1) {
        let url = '/webstories';
        if (tag) url += '/' + tag;
        if (page > 1) url += '?page=' + page;
        return url;
    }

    loadWebstories(tag = '', page = 1) {
        this.showLoading();

        const params = new URLSearchParams();
        if (tag) params.append('tag', tag);
        params.append('page', page);

        fetch(`/webstories/api?${params.toString()}`)
            .then(response => response.json())
            .then(data => {
                const chunkedHTML = this.createChunkedHTML(data.html);
                this.contentContainer.innerHTML = chunkedHTML;
                this.updatePagination(data.pagination);
                this.updateURL(tag, page);

                // Só inicia hover video se há conteúdo
                if (data.html.trim() !== '') {
                    this.startHoverVideo();
                }

                this.hideLoading();
            })
            .catch(error => {
                console.error('Erro ao carregar webstories:', error);
                // Em caso de erro, mostra mensagem
                this.contentContainer.innerHTML = `
                    <div class="container py-6">
                        <p class="text-center text-lg text-red-600">Erro ao carregar webstories. Tente novamente.</p>
                    </div>
                `;
                this.hideLoading();
            });
    }

    loadWebstoriesWithoutURL(tag = '', page = 1) {
        this.showLoading();

        const params = new URLSearchParams();
        if (tag) params.append('tag', tag);
        params.append('page', page);

        fetch(`/webstories/api?${params.toString()}`)
            .then(response => response.json())
            .then(data => {
                const chunkedHTML = this.createChunkedHTML(data.html);
                this.contentContainer.innerHTML = chunkedHTML;
                this.updatePagination(data.pagination);

                if (data.html.trim() !== '') {
                    this.startHoverVideo();
                }

                this.hideLoading();
            })
            .catch(error => {
                console.error('Erro ao carregar webstories:', error);
                // Em caso de erro, mostra mensagem
                this.contentContainer.innerHTML = `
                    <div class="container py-6">
                        <p class="text-center text-lg text-red-600">Erro ao carregar webstories. Tente novamente.</p>
                    </div>
                `;
                this.hideLoading();
            });
    }

    async startHoverVideo() {
        const YT = await WebStoriesList.loadYouTubeAPI();

        /* Stories */
        const allStories = document.querySelectorAll('.block-webstories-item');
        let currentStory = null;

        allStories.forEach(story => {
            story.addEventListener('click', () => {
                const id = story.dataset.id;
                if (!id) return;

                const contentEl = story.querySelector('.content');
                const isPlaying = story.classList.contains('playing');

                /* Toggle no mesmo card */
                if (isPlaying) {
                    story.querySelector('iframe')?.remove();
                    contentEl?.classList.remove('opacity-0', 'invisible');
                    story.classList.remove('playing');
                    currentStory = null;
                    return;
                }

                /* Remove player anterior */
                if (currentStory && currentStory !== story) {
                    const prevContent = currentStory.querySelector('.content');
                    currentStory.querySelector('iframe')?.remove();
                    prevContent?.classList.remove('opacity-0', 'invisible');
                    currentStory.classList.remove('playing');
                }

                /* Oculta thumbnail */
                contentEl?.classList.add('opacity-0', 'invisible');

                /* Wrapper para player */
                const wrapper = document.createElement('div');
                const iframeId = `yt-${crypto.randomUUID()}`;
                wrapper.id = iframeId;
                wrapper.className = 'w-full h-full absolute inset-0 rounded-xl';
                story.appendChild(wrapper);

                story.classList.add('playing');
                currentStory = story;

                /* Instancia player */
                new YT.Player(iframeId, {
                    videoId: id,
                    playerVars: {
                        autoplay: 1,
                        mute: 1,              // obrigatório p/ autoplay
                        playsinline: 1,
                        rel: 0,
                        enablejsapi: 1
                    },
                    // events: {
                    //     onReady: e => e.target.playVideo(),
                    //     // onStateChange: e => {
                    //     //     if (e.data === YT.PlayerState.PLAYING) {
                    //     //         /* desmute após breve delay */
                    //     //         setTimeout(() => {
                    //     //             if (e.target.getPlayerState() === YT.PlayerState.PLAYING) {
                    //     //                 e.target.unMute();
                    //     //             }
                    //     //         }, 500);
                    //     //     }
                    //     // }
                    // }
                });

                /* Ajusta permissões explicitamente */
                const iframe = wrapper.querySelector('iframe');
                if (iframe) {
                    iframe.allow =
                        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
                    iframe.allowFullscreen = true;
                }
            });
        });
    }

    initEvents() {
        this.filterSelect.addEventListener('change', () => {
            this.currentTag = this.filterSelect.value;
            this.currentPage = 1;
            this.loadWebstories(this.currentTag, this.currentPage);
        });

        // Intercepta cliques nos botões de paginação
        this.prevBtn.addEventListener('click', (e) => {
            e.preventDefault();

            if (this.prevBtn.disabled || this.currentPage <= 1 || this.isPrevDisabled) {
                return;
            }

            this.loadWebstories(this.currentTag, this.currentPage - 1);
        });

        this.nextBtn.addEventListener('click', (e) => {
            e.preventDefault();

            if (this.nextBtn.disabled || this.currentPage >= this.lastPage || this.isNextDisabled) {
                return;
            }

            this.loadWebstories(this.currentTag, this.currentPage + 1);
        });

        window.addEventListener('popstate', (event) => {
            if (event.state) {
                this.currentTag = event.state.tag || '';
                this.currentPage = event.state.page || 1;
                this.filterSelect.value = this.currentTag;
                this.loadWebstoriesWithoutURL(this.currentTag, this.currentPage);
            }
        });
    }
}

if (document.querySelector('.block-webstories-list')) {    
    new WebStoriesList();
}